module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAmCAMAAAAVzIDdAAAAP1BMVEUAAADT6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3rrtLGAAAAFHRSTlMA0uPcGxQPCr7p1sjDs05MLCckIOk+esgAAABoSURBVCjP7cxJEoAgEEPRNKDgPOX+ZzUlqJzB8q9SbxGUjFbWL1+Uea1knYGF3fbI1nHBRLq9yO7ICTGJjksOQYpAHEkfJMGTY4RqB5GjEwwtlMiYM0GusQzNDaJe0Avegtd7DaJ0wwk9gAdLPiKxYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specailPage/div2_tipline2.png
// module id = 99zw
// module chunks = 1